import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Logo = ({ theme, text, style, className, size }) => (
  <object
    data={`/media/logos/logo-${theme}${text ? '-with-text' : ''}.svg`}
    style={style}
    className={cx('gp-logo', size, { ['with-text']: text }, className)}
  />
)

Logo.propTypes = {
  theme: PropTypes.string,
  text: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'huge'])
}

Logo.defaultProps = {
  theme: 'dark',
  text: false,
  style: {},
  className: '',
  size: 'medium'
}

export default Logo
